/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const setRoadmapIsCreateEnabled =
	(roadmapIsCreateEnabled: boolean): Action<State> =>
	({ getState, setState }) => {
		const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();

		// skip store update if no state change
		if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) {
			return;
		}

		setState({ roadmapIsCreateEnabled });
	};

export const setRoadmapIsListEmpty =
	(roadmapIsListEmpty: boolean): Action<State> =>
	({ getState, setState }) => {
		const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();

		// skip store update if no state change
		if (currentRoadmapIsListEmpty === roadmapIsListEmpty) {
			return;
		}

		setState({ roadmapIsListEmpty });
	};
